module.exports = __webpack_public_path__ + "img/iadsa-logo.dbfeafa7.svg";